export const theme: ThemeType = {
  background: '#fef17e',
  playerOne: '#ffff00',
  playerTwo: '#00ff00',
  playerThree: '#ff0000',
  playerFour: '#4169e1',
  field: {
    background: '#fff',
    borderRadius: '18px',
    dropColor: '#808080',
  },
};

export interface ThemeType {
  background: string;
  playerOne: string;
  playerTwo: string;
  playerThree: string;
  playerFour: string;
  field: {
    background: string;
    borderRadius: string;
    dropColor: string;
  };
}

export default theme;
